import francoisMazon from '../../../../shared/customer-stories/francois-mazon';
import miguelineRosset from '../../../../shared/customer-stories/migueline-rosset';
import pierreBregou from '../../../../shared/customer-stories/pierre-bregou';

type CustomerType = {
  author: {
    name: string;
    job: string;
    city: string;
  };
  title: string;
  carousel: string;
};

const customers = [francoisMazon, miguelineRosset, pierreBregou];

function getCutomersData(customer: CustomerType) {
  const { author, title, carousel } = customer;

  return { author, title, carousel };
}

export const discoveryCustomers: Array<CustomerType> = customers.map(
  getCutomersData,
);
